module.exports = __webpack_public_path__ + "img/texiao-_0000s_0003_4.dd0d4f91.png";